import { FC } from "react";

import { APP_ENV } from "../../modules/auth/constants";

const Environment: FC = () => {
  return APP_ENV !== "production" ? (
    <div
      className={
        "position-absolute top-0 right-0 w-100 d-flex justify-content-center"
      }
      style={{
        zIndex: 9999999999999,
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
    >
      <span
        className={"text-white"}
        style={{
          fontSize: "13px",
        }}
      >
        Environnement: {APP_ENV}
      </span>
    </div>
  ) : (
    <></>
  );
};

export default Environment;
